import { Component, Inject } from "@angular/core";

import { Resolver } from "../concrete";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

export interface IntentDialogData
{
    readonly resolvers: Array<Resolver>;
}

@Component({
    selector: "intent-dialog-component",
    templateUrl: "./intentDialog.tmpl.html",
    standalone: false
})
export class IntentDialogComponent
{
    readonly resolversGrid: ReadonlyArray<ReadonlyArray<Resolver>>;

    constructor(
        private readonly dialogRef: MatDialogRef<IntentDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        private readonly data: IntentDialogData
    )
    {
        this.resolversGrid = this.chuck(this.data.resolvers, 3);
    }

    onIntentClicked(resolver: Resolver): void
    {
        this.dialogRef.close(resolver);
    }

    private chuck(array: Array<Resolver>, size: number): Array<Array<Resolver>>
    {
        const newArr: Array<Array<Resolver>> = [];
        for (let i = 0; i < array.length; i += size)
        {
            newArr.push(array.slice(i, i + size));
        }
        return newArr;
    }
}
